<script setup>
import { useHead } from '#imports'
import { computed } from 'vue'

const props = defineProps({
  title: {
    type: String,
    required: true
  },
  description: {
    type: String,
    required: true
  },
  canonicalUrl: {
    type: String,
    default: ''
  },
  ogImage: {
    type: String,
    default: '/static/assets/og-image.jpg'
  },
  ogType: {
    type: String,
    default: 'website'
  },
  robots: {
    type: String,
    default: 'index, follow'
  },
  structuredData: {
    type: Array,
    default: () => []
  }
})

const headConfig = computed(() => {
  const config = {
    title: props.title,
    meta: [
      { name: 'description', content: props.description },
      { name: 'robots', content: props.robots },
      // Open Graph
      { property: 'og:title', content: props.title },
      { property: 'og:description', content: props.description },
      { property: 'og:image', content: props.ogImage },
      { property: 'og:type', content: props.ogType },
      { property: 'og:url', content: props.canonicalUrl || 'https://www.mietfotobox.com/' },
      // Twitter
      { name: 'twitter:card', content: 'summary_large_image' },
      { name: 'twitter:title', content: props.title },
      { name: 'twitter:description', content: props.description },
      { name: 'twitter:image', content: props.ogImage }
    ],
    link: [
      { rel: 'canonical', href: props.canonicalUrl || 'https://www.mietfotobox.com/' }
    ]
  }

  if (Array.isArray(props.structuredData) && props.structuredData.length > 0) {
    config.script = props.structuredData.map(data => ({
      type: 'application/ld+json',
      // JSON.stringify mit fester Einrückung für konsistente Ausgabe
      innerHTML: JSON.stringify(data, null, 0)
    }))
  }
  
  return config
})

useHead(headConfig)
</script>

<template>
  <client-only>
    <div v-if="false"></div>
  </client-only>
</template>
